
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
// import { AppConstant } from './../../shared/constant/app.constant';
import { AuthHttp } from '../../admin/services/token.service';
import { Injectable } from '@angular/core';


import { AppConfigService } from '../../shared/services/app.config.service';

let AppConstant: any = {};
@Injectable()
export class ConditionPrecedentService {
    constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
        AppConstant = appConfigServ;
    }

    getAllConditionsPrecedent() {
        return this.http.get(`credit/condition-precedent-template`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    save(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/condition-precedent-template`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    update(body, id) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`credit/condition-precedent-template/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    getAllComplianceTimeline() {
        return this.http.get(`credit/compliance-timeline-template`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    saveComplianceTimeline(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/compliance-timeline-template`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateComplianceTimeline(body, id) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`credit/compliance-timeline-template/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    removeComplianceTimeline(id) {
        return this.http.get(`credit/compliance-timeline/remove/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    getAllTransactionDynamics() {
        return this.http.get(`credit/transaction-dynamics-template`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    saveTransactionDynamics(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/transaction-dynamics-template`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateTransactionDynamics(body, id) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`credit/transaction-dynamics-template/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    deleteCondition(id) {
        return this.http.get(`credit/condition-precedent-template/delete/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    getLoanSuggestedConditions(applicationDetailsId) {
        return this.http.get(`credit/suggested-conditions/${applicationDetailsId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLoanSuggestedConditionsByApplicationId(applicationId) {

        return this.http.get(`credit/suggested-conditions-byAppId/${applicationId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    saveLoanSuggestedConditions(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/suggested-conditions`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateLoanSuggestedConditions(body, id) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`credit/suggested-conditions-update/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    deleteLoanSuggestedConditions(conditionId) {
        return this.http.delete(`credit/suggested-conditions-delete/${conditionId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
}